import { render } from "./authors.vue?vue&type=template&id=74820476&scoped=true"
import script from "./authors.js?vue&type=script&lang=js&external"
export * from "./authors.js?vue&type=script&lang=js&external"

import "./authors.css?vue&type=style&index=0&id=74820476&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74820476"]])

export default __exports__